import React from 'react';
import { LogoFull } from '../components/Logo';
import './MaintenancePage.css';

function MaintenancePage({ message, isNetworkError }) {
  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        <div className="maintenance-logo">
          <LogoFull height={48} />
        </div>

        <div className="maintenance-icon">🔧</div>

        <h1 className="maintenance-title">
          {isNetworkError ? 'Sem conexão com o servidor' : 'Sistema em Manutenção'}
        </h1>

        <p className="maintenance-message">
          {message || (isNetworkError
            ? 'Não foi possível conectar ao servidor. Verifique sua conexão ou aguarde o serviço ser restabelecido.'
            : 'O sistema está temporariamente indisponível para manutenção. Por favor, tente novamente em breve.'
          )}
        </p>

        <div className="maintenance-status">
          <span className="maintenance-dot" />
          {isNetworkError ? 'Servidor inacessível' : 'Manutenção em andamento'}
        </div>

        <button className="maintenance-retry-btn" onClick={() => window.location.reload()}>
          ↻ Tentar novamente
        </button>
      </div>
    </div>
  );
}

export default MaintenancePage;
